import {
  TanStackDatagridColumn,
  TanStackDatagridFilter
} from '../../components/TanStackDataGrid/TanStackDatagrid'

export const applyColumnFilters = <TData,>(
  rows: TData[],
  filters: TanStackDatagridFilter[],
  columns: TanStackDatagridColumn<TData>[]
): TData[] => {
  return rows.filter((row) =>
    filters.every((filter) => {
      if (!filter.value) return true

      const column = columns.find((candidate) => candidate.id === filter.columnId)

      return String(column?.accessor(row) ?? '')
        .toLowerCase()
        .includes(filter.value.toLowerCase())
    })
  )
}
